"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Sketchpad = /** @class */ (function () {
    function Sketchpad(el, opts) {
        this.sketching = false;
        this.isEraserActive = false;
        this.eraserPt = undefined;
        this.shapePaths = [];
        this.drawingShapePath = new ShapePath();
        this.logPrefixId = 'Sketchpad[]';
        // Options
        this.logging = false;
        this.loggingVerbose = false;
        this.readOnly = false;
        this.lineWidth = 1;
        this.lineColor = '#000';
        this.lineCap = 'round';
        this.lineJoin = 'round';
        this.lineMiterLimit = 10;
        this.eraserSize = 20;
        this.canvasWidth = 0;
        this.canvasHeight = 0;
        // SW specific data
        this.currentLayerId = -1;
        this.layerVisibility = {};
        if (el == null) {
            throw new Error('Must pass in a container element');
        }
        this.logPrefixId = 'Sketchpad[' + el.id + ']';
        if (opts != null) {
            this.setOptions(opts);
        }
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
        var width = (opts === null || opts === void 0 ? void 0 : opts.width) || el.clientWidth;
        var height = (opts === null || opts === void 0 ? void 0 : opts.height) || el.clientHeight;
        this.setCanvasSize(width, height);
        el.appendChild(this.canvas);
        if (this.shapePaths.length > 0) {
            this.redraw();
        }
        this.listen();
        this.log('Initialized');
    }
    Object.defineProperty(Sketchpad.prototype, "opts", {
        // v2.0 - Remove
        get: function () {
            return {
                backgroundColor: this.backgroundColor,
                readOnly: this.readOnly,
                width: this.canvas.width,
                height: this.canvas.height,
                line: {
                    size: this.lineWidth,
                    color: this.lineColor,
                    cap: this.lineCap,
                    join: this.lineJoin,
                    miterLimit: this.lineMiterLimit,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Load shape path data into the sketchpad
     * @param shapePaths shape path data to load into the sketchpad
     */
    Sketchpad.prototype.loadShapePaths = function (shapePaths) {
        this.shapePaths = shapePaths.map(function (s) { return ShapePath.fromObj(s); }).filter(function (p) { return !p.isEmpty(); });
        this.redraw();
        this.log('Loaded shape paths: ' + this.shapePaths.length);
    };
    /**
     * Get shape path data of the sketchpad
     * @returns shape path data of the sketchpad
     */
    Sketchpad.prototype.getShapePaths = function () {
        return this.shapePaths.map(function (s) { return s.toObj(); });
    };
    /**
     * Interpolates the points of a shape path as line segments.
     * @param shapePathLike A shape path object with points and line color
     * @returns A new shape path object with interpolated points
     */
    Sketchpad.prototype.interpolateLegacyShapePath = function (shapePathLike) {
        var inputShapePath = ShapePath.fromObj(shapePathLike);
        // Failsafe for erroneous large shapes
        if (inputShapePath.bounds.x > this.canvasWidth || inputShapePath.bounds.y > this.canvasHeight) {
            return ShapePath.emptyCopy(inputShapePath).toObj();
        }
        var interpolatedShapePath = this.interpolateShapePath(inputShapePath, 2);
        return interpolatedShapePath.toObj();
    };
    // Converts to image File
    Sketchpad.prototype.toDataURL = function (type) {
        return this.canvas.toDataURL(type);
    };
    // Set the size of canvas
    Sketchpad.prototype.setCanvasSize = function (width, height) {
        this.canvas.setAttribute('width', width.toString());
        this.canvas.setAttribute('height', height.toString());
        this.canvas.style.width = width + 'px';
        this.canvas.style.height = height + 'px';
        this.canvasWidth = width;
        this.canvasHeight = height;
        this.log('Canvas size set to: ' + width + 'x' + height);
    };
    // Set the eraser size
    Sketchpad.prototype.setEraserSize = function (size) {
        this.eraserSize = size;
        this.redraw();
        this.log('Eraser size set to: ' + size);
    };
    Sketchpad.prototype.setEraserMode = function (eraserMode) {
        if (eraserMode) {
            this.eraserModeOn();
        }
        else {
            this.eraserModeOff();
        }
        this.log('Eraser mode: ' + eraserMode);
    };
    Sketchpad.prototype.getEraserMode = function () {
        return this.isEraserActive === true;
    };
    // Set the line width
    Sketchpad.prototype.setLineSize = function (size) {
        this.lineWidth = size;
        this.log('Line size set to: ' + size);
    };
    Sketchpad.prototype.getLineSize = function () {
        return this.lineWidth;
    };
    // Set the line color
    Sketchpad.prototype.setLineColor = function (color) {
        this.lineColor = color;
        this.log('Line color set to: ' + color);
    };
    Sketchpad.prototype.getLineColor = function () {
        return this.lineColor;
    };
    // Set whether or not new shapes can be drawn on the canvas
    Sketchpad.prototype.setReadOnly = function (readOnly) {
        this.readOnly = readOnly;
        this.log('Read only: ' + readOnly);
    };
    // Clear the sketchpad
    Sketchpad.prototype.clear = function () {
        this.shapePaths = [];
        this.redraw();
        this.log('Cleared');
    };
    Sketchpad.prototype.setCurrentLayerId = function (layerId) {
        this.currentLayerId = layerId;
        this.log('Current layer id set to: ' + layerId);
    };
    Sketchpad.prototype.getCurrentLayerId = function () {
        return this.currentLayerId;
    };
    Sketchpad.prototype.setLayerVisibility = function (layerId, isVisible) {
        this.layerVisibility[layerId] = isVisible;
        this.redraw();
        this.log('Layer visibility set for layer id ' + layerId + ': ' + isVisible);
    };
    Sketchpad.prototype.getLayerVisibility = function (layerId) {
        return this.layerVisibility[layerId] || false;
    };
    Sketchpad.prototype.getAllLayerVisibility = function () {
        return this.layerVisibility;
    };
    //  Get the line size relative to the size of the canvas
    Sketchpad.prototype.getLineSizeRelativeToCanvas = function (width) {
        return width / this.canvas.width;
    };
    Sketchpad.prototype.clearLayer = function (layerId) {
        if (this.shapePaths.some(function (s) { return s.layerid === layerId; })) {
            this.shapePaths = this.shapePaths.filter(function (s) { return s.layerid !== layerId; });
            this.redraw();
            this.log('Cleared layer id: ' + layerId);
            if (this.onChange) {
                this.onChange();
            }
        }
    };
    Sketchpad.prototype.removeShapePathAtIndex = function (index) {
        var spliced = this.shapePaths.splice(index, 1);
        this.redraw();
        this.log('Removed shape path at index: ' + index);
        if (spliced.length > 0 && this.onChange) {
            this.onChange();
        }
    };
    Sketchpad.prototype.moveShapePathToLayer = function (shapePathIndex, layerId) {
        var shapePath = this.shapePaths[shapePathIndex];
        shapePath.layerid = layerId;
        this.redraw();
        this.log('Moved shape path at index ' + shapePathIndex + ' to layer id ' + layerId);
    };
    Sketchpad.prototype.setOptions = function (opts) {
        var _a, _b, _c, _d;
        if (opts.logging !== undefined) {
            if (opts.logging === 'verbose') {
                this.logging = true;
                this.loggingVerbose = true;
            }
            else {
                this.logging = opts.logging === true;
            }
        }
        if (opts.backgroundColor) {
            this.backgroundColor = opts.backgroundColor;
        }
        if ((_a = opts.line) === null || _a === void 0 ? void 0 : _a.size) {
            this.lineWidth = opts.line.size;
        }
        if ((_b = opts.line) === null || _b === void 0 ? void 0 : _b.cap) {
            this.lineCap = opts.line.cap;
        }
        if ((_c = opts.line) === null || _c === void 0 ? void 0 : _c.join) {
            this.lineJoin = opts.line.join;
        }
        if ((_d = opts.line) === null || _d === void 0 ? void 0 : _d.miterLimit) {
            this.lineMiterLimit = opts.line.miterLimit;
        }
        if (opts.onDrawEnd) {
            this.onDrawEnd = opts.onDrawEnd;
        }
        if (opts.onChange) {
            this.onChange = opts.onChange;
        }
    };
    // For a given event, get the point at which the event occurred
    // relative to the canvas
    Sketchpad.prototype.getCursorRelativeToCanvas = function (e) {
        var point;
        var rect = this.canvas.getBoundingClientRect();
        if (isTouchEvent(e)) {
            var touchEvent = e;
            point = new Point(touchEvent.touches[0].clientX - rect.left, touchEvent.touches[0].clientY - rect.top);
        }
        else {
            var mouseEvent = e;
            point = new Point(mouseEvent.clientX - rect.left, mouseEvent.clientY - rect.top);
        }
        return point;
    };
    Sketchpad.prototype.midPoint = function (p1, p2) {
        return new Point((p1.x + p2.x) / 2, (p1.y + p2.y) / 2);
    };
    // Erase the entire canvas
    Sketchpad.prototype.clearCanvas = function () {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (this.backgroundColor) {
            this.ctx.fillStyle = this.backgroundColor;
            this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
    };
    // Draw a single shape path with line segments
    Sketchpad.prototype.drawWithSegments = function (shapePath) {
        if (this.layerVisibility[shapePath.layerid] !== true) {
            return;
        }
        if (shapePath.points == null)
            return;
        this.ctx.beginPath();
        for (var i = 0; i < shapePath.points.length - 1; i++) {
            var currentPoint = shapePath.points[i];
            var nextPoint = shapePath.points[i + 1];
            if (!(currentPoint.skipped || (nextPoint && nextPoint.skipped))) {
                var e = currentPoint;
                var n = nextPoint;
                this.ctx.moveTo(e.x, e.y);
                this.ctx.lineTo(n.x, n.y);
            }
        }
        this.ctx.closePath();
        if (shapePath.lineColor) {
            this.ctx.strokeStyle = shapePath.lineColor;
        }
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.lineJoin = this.lineJoin;
        this.ctx.lineCap = this.lineCap;
        this.ctx.miterLimit = this.lineMiterLimit;
        this.ctx.stroke();
    };
    Sketchpad.prototype.drawWithQuadraticCurve = function (shapePath) {
        if (shapePath.points == null)
            return;
        this.ctx.beginPath();
        var originPt = shapePath.points[0];
        var controlPt = originPt;
        var destinationPt = originPt;
        if (shapePath.points.length > 1) {
            destinationPt = this.midPoint(shapePath.points[0], shapePath.points[1]);
        }
        if (!(originPt.skipped || (destinationPt && destinationPt.skipped))) {
            this.ctx.moveTo(originPt.x, originPt.y);
            this.ctx.quadraticCurveTo(controlPt.x, controlPt.y, destinationPt.x, destinationPt.y);
        }
        for (var i = 1; i < shapePath.points.length - 1; i++) {
            originPt = destinationPt;
            controlPt = shapePath.points[i];
            destinationPt = this.midPoint(shapePath.points[i], shapePath.points[i + 1]);
            if (!(originPt.skipped || (destinationPt && destinationPt.skipped))) {
                this.ctx.quadraticCurveTo(controlPt.x, controlPt.y, destinationPt.x, destinationPt.y);
            }
        }
        if (shapePath.lineColor) {
            this.ctx.strokeStyle = shapePath.lineColor;
        }
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.lineJoin = this.lineJoin;
        this.ctx.lineCap = this.lineCap;
        this.ctx.miterLimit = this.lineMiterLimit;
        this.ctx.stroke();
    };
    Sketchpad.prototype.beginNewShapePathWithPoints = function (points) {
        this.drawingShapePath.points = points;
        this.drawingShapePath.lineColor = this.lineColor;
        this.drawingShapePath.layerid = this.currentLayerId;
    };
    Sketchpad.prototype.pushPoint = function (point) {
        this.drawingShapePath.points.push(point);
    };
    // Redraw the whole canvas
    Sketchpad.prototype.redraw = function () {
        var _this = this;
        this.clearCanvas();
        this.shapePaths.forEach(function (s) { return _this.drawWithSegments(s); });
        if (this.isEraserActive) {
            if (this.eraserPt) {
                this.ctx.save();
                this.ctx.beginPath();
                this.ctx.arc(this.eraserPt.x, this.eraserPt.y, this.eraserSize / 2, 0, 2 * Math.PI);
                this.ctx.fillStyle = 'rgb(0 0 0 / 20%)';
                this.ctx.fill();
                this.ctx.strokeStyle = 'rgb(0 0 0 / 50%)';
                this.ctx.lineWidth = 2;
                this.ctx.stroke();
                this.ctx.restore();
            }
        }
        else {
            if (this.sketching) {
                this.drawWithQuadraticCurve(this.drawingShapePath);
            }
        }
    };
    Sketchpad.prototype.listen = function () {
        var _this = this;
        ['mousedown', 'touchstart'].forEach(function (name) {
            return _this.canvas.addEventListener(name, function (e) { return _this.startStrokeHandler(e); });
        });
        ['mousemove', 'touchmove'].forEach(function (name) { return _this.canvas.addEventListener(name, function (e) { return _this.drawStrokeHandler(e); }); });
        ['mouseup', 'mouseleave', 'touchend'].forEach(function (name) {
            return _this.canvas.addEventListener(name, function (e) { return _this.endStrokeHandler(e); });
        });
    };
    Sketchpad.prototype.startStrokeHandler = function (e) {
        e.preventDefault();
        if (this.readOnly) {
            return;
        }
        this.sketching = true;
        var point = this.getCursorRelativeToCanvas(e);
        if (this.isEraserActive) {
            this.erasePoints(point);
            this.eraserPt = point;
        }
        else {
            this.beginNewShapePathWithPoints([point]);
        }
        this.redraw();
        this.log('Start stroke: mode - ' + (this.isEraserActive ? 'eraser' : 'draw'));
    };
    Sketchpad.prototype.drawStrokeHandler = function (e) {
        var point = this.getCursorRelativeToCanvas(e);
        e.preventDefault();
        if (this.sketching) {
            if (this.isEraserActive) {
                this.erasePoints(point);
                this.eraserPt = point;
            }
            else {
                this.pushPoint(point);
            }
            this.redraw();
        }
        else if (this.isEraserActive) {
            this.eraserPt = point;
            this.redraw();
        }
    };
    Sketchpad.prototype.endStrokeHandler = function (e) {
        e.preventDefault();
        this.eraserPt = undefined;
        if (!this.sketching) {
            if (this.isEraserActive) {
                this.redraw();
            }
            return;
        }
        this.sketching = false;
        if (isTouchEvent(e)) {
            return; // touchend events do not have a position
        }
        var padModified = false;
        var point = this.getCursorRelativeToCanvas(e);
        if (this.isEraserActive) {
            this.erasePoints(point);
            padModified = this.processShapePathsAfterErasing();
        }
        else {
            this.pushPoint(point);
            if (this.drawingShapePath.points.length > 1) {
                this.shapePaths.push(this.interpolateShapePath(this.drawingShapePath, 5));
                padModified = true;
            }
        }
        this.redraw();
        this.log('End stroke');
        if (this.onDrawEnd) {
            this.onDrawEnd(padModified);
        }
        if (padModified && this.onChange) {
            this.onChange();
        }
    };
    Sketchpad.prototype.erasePoints = function (cursor) {
        var _this = this;
        var eraserSize = this.eraserSize / 2;
        var areaOfEraser = eraserSize * eraserSize;
        var pointsSkippedCount = 0;
        this.shapePaths.forEach(function (shapePath) {
            if (shapePath.layerid !== _this.currentLayerId) {
                return;
            }
            shapePath.points.forEach(function (point) {
                if (point.skipped) {
                    return;
                }
                var dx = point.x - cursor.x;
                var dy = point.y - cursor.y;
                var distanceSquared = dx * dx + dy * dy;
                if (distanceSquared <= areaOfEraser) {
                    point.skipped = true;
                    pointsSkippedCount++;
                    shapePath.hasSkippedPoints = true;
                }
            });
        });
        if (pointsSkippedCount > 0) {
            this.logVerbose('Erased ' + pointsSkippedCount + ' points');
        }
    };
    Sketchpad.prototype.processShapePathsAfterErasing = function () {
        var newShapePaths = [];
        var numOldShapePaths = this.shapePaths.length;
        var shapePathsModified = false;
        for (var i = 0; i < numOldShapePaths; i++) {
            var shapePath = this.shapePaths[i];
            if (shapePath.hasSkippedPoints === false) {
                newShapePaths.push(shapePath);
                continue;
            }
            shapePathsModified = true;
            var points = shapePath.points || [];
            var newShapePath = ShapePath.emptyCopy(shapePath);
            for (var j = 0; j < points.length; j++) {
                if (points[j].skipped) {
                    if (newShapePath.points.length > 1) {
                        newShapePaths.push(newShapePath);
                    }
                    newShapePath = ShapePath.emptyCopy(shapePath);
                }
                else {
                    newShapePath.points.push(points[j]);
                }
            }
            if (newShapePath.points.length > 1) {
                newShapePaths.push(newShapePath);
            }
        }
        newShapePaths.forEach(function (s) { return s.updateBounds(); });
        this.shapePaths = newShapePaths;
        if (shapePathsModified) {
            var numNewShapePaths = newShapePaths.length;
            this.log('After erasing: ' + numNewShapePaths + ' shape paths, before: ' + numOldShapePaths);
        }
        else {
            this.log('No shape paths were modified after erasing');
        }
        return shapePathsModified;
    };
    /**
     * Interpolates the points of a shape path with a given interval as line segments.
     * @param shapePath source shape path
     * @param interval point interval / distance
     * @returns new shape path with interpolated points
     */
    Sketchpad.prototype.interpolateShapePath = function (shapePath, interval) {
        var points = shapePath.points || [];
        var newPoints = [];
        var originPt = points[0];
        var controlPt = originPt;
        var destinationPt = originPt;
        if (points.length > 1) {
            destinationPt = this.midPoint(points[0], points[1]);
            var distance = Math.hypot(destinationPt.x - originPt.x, destinationPt.y - originPt.y);
            var numIntervals = Math.max(1, Math.ceil(distance / interval));
            var interpolatedPoints = this.interpolateQuadraticCurve(originPt, controlPt, destinationPt, numIntervals);
            // newPoints.push(...interpolatedPoints);
            // newPoints = newPoints.concat(interpolatedPoints);
            interpolatedPoints.forEach(function (p) { return newPoints.push(p); });
        }
        for (var j = 1; j < points.length - 1; j++) {
            originPt = destinationPt;
            controlPt = points[j];
            destinationPt = this.midPoint(points[j], points[j + 1]);
            var distance = Math.hypot(destinationPt.x - originPt.x, destinationPt.y - originPt.y);
            var numIntervals = Math.max(1, Math.ceil(distance / interval));
            var interpolatedPoints = this.interpolateQuadraticCurve(originPt, controlPt, destinationPt, numIntervals);
            // newPoints.push(...interpolatedPoints);
            // newPoints = newPoints.concat(interpolatedPoints);
            interpolatedPoints.forEach(function (p) { return newPoints.push(p); });
        }
        var newShapePath = ShapePath.emptyCopy(shapePath);
        newShapePath.points = newPoints;
        newShapePath.isInterpolationDone = true;
        newShapePath.updateBounds();
        return newShapePath;
    };
    Sketchpad.prototype.eraserModeOn = function () {
        this.isEraserActive = true;
        this.redraw();
    };
    Sketchpad.prototype.eraserModeOff = function () {
        this.isEraserActive = false;
        this.redraw();
    };
    Sketchpad.prototype.interpolateQuadraticCurve = function (originPt, controlPt, destinationPt, numPoints) {
        var interpolatedPoints = [];
        for (var pt = 0; pt < numPoints; pt += 1) {
            var t = pt / numPoints;
            var x = Math.pow(1 - t, 2) * originPt.x + 2 * (1 - t) * t * controlPt.x + Math.pow(t, 2) * destinationPt.x;
            var y = Math.pow(1 - t, 2) * originPt.y + 2 * (1 - t) * t * controlPt.y + Math.pow(t, 2) * destinationPt.y;
            interpolatedPoints.push(new Point(x, y));
        }
        return interpolatedPoints;
    };
    Sketchpad.prototype.log = function (message) {
        if (this.logging) {
            console.log(this.logPrefixId + ' (inf): ' + message);
        }
    };
    Sketchpad.prototype.logVerbose = function (message) {
        if (this.logging && this.loggingVerbose) {
            console.log(this.logPrefixId + ' (ver): ' + message);
        }
    };
    return Sketchpad;
}());
exports.default = Sketchpad;
function isTouchEvent(e) {
    return e.type.indexOf('touch') !== -1; // v2.0 - Switch to startsWith
}
var Point = /** @class */ (function () {
    function Point(x, y) {
        this.x = x;
        this.y = y;
    }
    return Point;
}());
var Rect = /** @class */ (function () {
    function Rect(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    return Rect;
}());
var ShapePath = /** @class */ (function () {
    function ShapePath() {
        this.points = [];
        this.lineColor = 'rgb(0, 0, 0)';
        this.layerid = -1;
        this.isInterpolationDone = false;
        this.bounds = new Rect(0, 0, 0, 0);
        this.hasSkippedPoints = false;
    }
    ShapePath.fromObj = function (s) {
        var shapePath = new ShapePath();
        shapePath.points = s.points;
        shapePath.lineColor = s.lineColor;
        shapePath.layerid = s.layerid;
        shapePath.isInterpolationDone = s.isInterpolationDone;
        shapePath.updateBounds();
        return shapePath;
    };
    /**
     * Creates an empty (no points) copy of a shape path object.
     * @param shapePath A shape path object to copy.
     * @returns Copied shape path object.
     */
    ShapePath.emptyCopy = function (shapePath) {
        var newShapePath = new ShapePath();
        newShapePath.lineColor = shapePath.lineColor;
        newShapePath.layerid = shapePath.layerid;
        newShapePath.isInterpolationDone = shapePath.isInterpolationDone;
        return newShapePath;
    };
    ShapePath.prototype.toObj = function () {
        return {
            points: this.points,
            lineColor: this.lineColor,
            layerid: this.layerid,
            isInterpolationDone: this.isInterpolationDone,
            bounds: this.bounds,
        };
    };
    ShapePath.prototype.updateBounds = function () {
        var minX = Number.MAX_VALUE;
        var minY = Number.MAX_VALUE;
        var maxX = Number.MIN_VALUE;
        var maxY = Number.MIN_VALUE;
        if (Array.isArray(this.points)) {
            this.points.forEach(function (point) {
                minX = Math.min(minX, point.x);
                minY = Math.min(minY, point.y);
                maxX = Math.max(maxX, point.x);
                maxY = Math.max(maxY, point.y);
            });
        }
        var minW = 20;
        var minH = 20;
        if (maxX - minX < minW) {
            minX -= minW / 2;
            maxX += minW / 2;
        }
        if (maxY - minY < minH) {
            minY -= minH / 2;
            maxY += minH / 2;
        }
        this.bounds.x = minX;
        this.bounds.y = minY;
        this.bounds.width = maxX - minX;
        this.bounds.height = maxY - minY;
    };
    ShapePath.prototype.isEmpty = function () {
        return !(Array.isArray(this.points) && this.points.length > 1);
    };
    return ShapePath;
}());
